import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  card: {
    border: '1px solid #E0E0E0',
    borderRadius: 12,
    backgroundColor: '#FFFFFF',
    overflow: 'hidden',
  },
  cardBody: {
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2),
      gap: theme.spacing(2),
    },
  },
  requestBanner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    padding: theme.spacing(1.5, 2),
    borderRadius: 12,
    backgroundColor: '#E0EAFF',
    border: '1px solid #C5D4FF',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  requestBannerCopy: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    minWidth: 0,
    flex: '1 1 auto',
  },
  requestBannerIcon: {
    color: '#0053FF',
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  requestBannerText: {
    fontSize: '0.875rem',
    lineHeight: 1.4,
    color: '#172024',
    margin: 0,
    display: 'flex',
    alignItems: 'center',
  },
  requestBannerButton: {
    borderRadius: 20,
    textTransform: 'none',
    fontWeight: 700,
    fontSize: '0.9375rem',
    padding: theme.spacing(1, 2.5),
    whiteSpace: 'nowrap',
    flexShrink: 0,
    boxShadow: 'none',
    '&:hover': {
      boxShadow: '0 4px 12px rgba(0, 83, 255, 0.28)',
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  ratingSummary: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2.5),
    padding: theme.spacing(2.5),
    borderRadius: 12,
    backgroundColor: '#F4F7F9',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      textAlign: 'center',
    },
  },
  coachAvatar: {
    width: 80,
    height: 80,
    fontSize: '1.5rem',
    fontWeight: 700,
    color: '#00205B',
    backgroundColor: '#E8F1FF',
    textTransform: 'uppercase',
    border: '2px solid #E0E0E0',
    boxSizing: 'border-box',
    flexShrink: 0,
  },
  ratingDetails: {
    minWidth: 0,
  },
  averageRating: {
    fontSize: '2rem',
    fontWeight: 700,
    lineHeight: 1,
    color: '#00205B',
    marginBottom: theme.spacing(0.75),
  },
  ratingStars: {
    marginBottom: theme.spacing(1),
    lineHeight: 1,
    '& .MuiIconButton-root': {
      padding: theme.spacing(0, 0.25),
      marginLeft: -3,
      '&:first-child': {
        marginLeft: 0,
      },
    },
    '& .MuiSvgIcon-root': {
      fontSize: '1.5rem',
    },
  },
  ratingStarButton: {
    padding: theme.spacing(0, 0.25),
    marginLeft: -3,
    '&:first-child': {
      marginLeft: 0,
    },
  },
  reviewCount: {
    fontSize: '0.875rem',
    lineHeight: 1.4,
    color: theme.palette.text.secondary,
  },
  reviewCountNumber: {
    fontWeight: 700,
    color: theme.palette.text.primary,
  },
  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  sectionTitle: {
    fontWeight: 700,
    fontSize: '1rem',
    lineHeight: 1.3,
    color: '#172024',
  },
  reviewsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    minWidth: 0,
  },
  loadMoreSentinel: {
    width: '100%',
    height: 1,
  },
}))

export default useStyles
